const inline = (line, key) =>
  line.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") && part.length > 4
      ? <strong key={`${key}-${i}`} className="font-bold text-slate-900">{part.slice(2, -2)}</strong>
      : part);

export default function RichText({ text = "", className = "", testid }) {
  const paras = text.replace(/\r/g, "").split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);
  return (
    <div data-testid={testid} className={`space-y-4 leading-relaxed text-slate-600 ${className}`}>
      {paras.map((p, i) => {
        const lines = p.split("\n");
        return <p key={i}>{lines.map((l, j) => <span key={j}>{inline(l, `${i}-${j}`)}{j < lines.length - 1 && <br />}</span>)}</p>;
      })}
    </div>
  );
}
